import { UserRole, UserRoleView } from 'providence-types';
import { OptionProps } from '../interfaces';

export const USER_ROLE_OPTIONS: OptionProps[] = Object.entries(
  UserRoleView,
).map(([key, viewValue]: [string, UserRoleView]) => ({
  viewValue,
  value: UserRole[key as keyof typeof UserRoleView],
}));
